import { type PropsWithChildren } from 'react'
import { Box } from '../../primitives/Box'
import { spacing } from '../../theme'

type Props = PropsWithChildren

export const ListItemIllustration = ({ children }: Props) => (
  <Box
    className="DhlListItem-illustration"
    sx={{
      display: 'inline-flex',
      boxSizing: 'content-box',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
      lineHeight: 0,
      width: spacing(10.5),
      minWidth: spacing(10.5),
      height: spacing(7),
      pr: spacing(1.75),

      svg: {
        width: 'auto',
      },
    }}
  >
    {children}
  </Box>
)
